const mutations = {
  getDonasis: (state, donasi) => {
    state.donasi = donasi;
  },
  getDonasi: (state, donasi_id) => {
    state.donasi_id = donasi_id;
  },
  getDonasi2: (state, donasi) => {
    state.donasi = donasi;
  },
  postDonasi: (state, new_donasi) => {
    state.donasi.push(new_donasi);
  },
  updateDonasis: (state, new_status) => {
    state.donasi = state.donasi.map((donasi) => {
      if (donasi.id === new_status.donasi_id) {
        return Object.assign({}, donasi, new_status.status);
      }
      return donasi;
    });
  },
  putDonasi: (state, payload) => {
    state.donasi = state.donasi.map((donasi) => {
      if (donasi.donasi_id === payload.id) {
        return Object.assign({}, donasi, payload.formData);
      }
      return donasi;
    });
  },
  delDonasi(state, id) {
    const index = state.donasi.findIndex(donasi => donasi.donasi_id == id);
    state.donasi.splice(index, 1);
  },
};

export default mutations;
